import React from 'react';
import './Section3.css';
import popupImage from '../assets/about-20.jpg';
import vendorImage from '../assets/about-21.jpg';

const Section3 = () => {
  return (
    <section className="section3">

      {/* LEFT BLOCK: POP-UP */}
      <a href="/pop-up-events" className="section3-link">
        <div className="section3-half section3-popup">
          <div className="section3-image">
            <img src={popupImage} alt="Upcoming Pop-Up Event" />
          </div>
          <div className="section3-content">
            <p className="section3-label">UPCOMING EVENT</p>
            <h2 className="section3-heading">Discover Our Next Pop-Up</h2>
            <p className="section3-text">
              Meet your favourite local vendors in person, try exclusive products, and join the Maplee community on the ground.
            </p>
          </div>
        </div>
      </a>

      {/* RIGHT BLOCK: VENDOR */}
      <a href="https://www.maplee.ca/auth/sign-up" className="section3-link-2">
        <div className="section3-half section3-vendor">
          <div className="section3-image">
            <img src={vendorImage} alt="Vendor showcasing products" />
          </div>
          <div className="section3-content">
            <p className="section3-label">JOIN THE MARKET</p>
            <h2 className="section3-heading">Become a Maplee Vendor</h2>
            <p className="section3-text">
              Share your story, reach new customers, and join a supportive community of creators, makers, and entrepreneurs.
            </p>
          </div>
        </div>
      </a>

    </section>
  );
};

export default Section3;